applicationOverview.classy.controller({
    name: 'RecommendedAwardController',
    inject: ['$scope', 'ApplicationService', 'CalculationService', 'SchoolModelService'],
    init: function ()
    {
    	this.$.CalculationService = this.CalculationService;
        this.$.CalculationService.calcRecommendedAward();
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        var $window = $(window).on('resize', function(){
            var height = $(this).height() - 159;
            $('.determine-award-container').css("height", height + 'px');
        }).trigger('resize');
    }
});
